var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-main",
    [
      _c("div", { staticClass: "login-background" }, [
        _c(
          "video",
          {
            attrs: {
              autoplay: "",
              loop: "",
              muted: "",
              playsinline: "",
              poster: require("@/assets/img/3.png"),
            },
            domProps: { muted: true },
          },
          [
            _c("source", {
              attrs: {
                src: "https://d2bt60lg5oycgc.cloudfront.net/30/driblab-login-intro-video.mp4",
                type: "video/mp4",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "fill-height pt-10", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticStyle: { "z-index": "1" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column align-center justify-center",
                  attrs: { cols: "12" },
                },
                [
                  _c("v-img", {
                    staticClass: "white--text my-10",
                    attrs: {
                      "max-width": "300px",
                      src: require("@/assets/img/driblab_white_box_pro.png"),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-start justify-center flex-wrap",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "MaterialCardLogin",
                    {
                      staticClass: "mt-10",
                      attrs: {
                        color: _vm.$vuetify.theme.dark
                          ? "secondary"
                          : "brandDark",
                        width: "450px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "heading",
                          fn: function () {
                            return [
                              _c(
                                "h2",
                                {
                                  staticClass: "white--text header-font",
                                  attrs: { align: "center" },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.login")))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              attrs: { name: "form", "lazy-validation": "" },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleLogin.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "v-card-text",
                                {},
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0 me-3",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.username")))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      name: "username",
                                      rules: _vm.emailRules,
                                      "prepend-inner-icon": "person",
                                      placeholder: " ",
                                      type: "text",
                                    },
                                    model: {
                                      value: _vm.user.username,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.user, "username", $$v)
                                      },
                                      expression: "user.username",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0 me-3",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.password")))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      id: "password",
                                      name: "password",
                                      rules: _vm.passwordRules,
                                      "prepend-inner-icon": "lock",
                                      placeholder: " ",
                                      type: "password",
                                    },
                                    model: {
                                      value: _vm.user.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.user, "password", $$v)
                                      },
                                      expression: "user.password",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.message
                                ? _c(
                                    "v-alert",
                                    {
                                      staticClass: "body-1",
                                      attrs: { type: "error" },
                                    },
                                    [_vm._v(_vm._s(_vm.message))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                {
                                  staticClass:
                                    "justify-center pa-1 py-xl-0 px-xl-0",
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "elevation-0 monospace-font white--text",
                                      attrs: {
                                        type: "submit",
                                        rounded: "",
                                        loading: _vm.loading,
                                        color: _vm.$vuetify.theme.dark
                                          ? "secondary"
                                          : "brandBlue",
                                        block: "",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.enter")))]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                { staticClass: "justify-center pt-3" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "justify-center subheader-font",
                                      attrs: {
                                        text: "",
                                        small: "",
                                        color: "brandDark",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onForgotPasswordClick()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("login.forgotMyPassword"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      staticClass: "my-10 pa-5",
                      style: {
                        "margin-left": _vm.$vuetify.breakpoint.mdAndUp
                          ? "80px"
                          : "",
                      },
                      attrs: { elevation: "0", outlined: "", width: "450px" },
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass:
                            "header-font primary--text pa-0 d-flex align-center",
                          staticStyle: { "font-size": "22px" },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mb-2 me-1",
                              attrs: { color: "secondary" },
                            },
                            [_vm._v("volume_up")]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("login.newsTitle")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "pa-0" },
                        [
                          _c("v-progress-linear", {
                            staticClass: "mb-3",
                            attrs: {
                              value: "100",
                              color: "secondary",
                              rounded: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "body-1 primary--text mb-5",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("login.newsText")),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text me-2",
                                  attrs: {
                                    rounded: "",
                                    outlined: "",
                                    small: "",
                                    color: "primary",
                                    href: "https://www.driblab.com/blog/speed-and-endurance-two-new-driblab-scores-to-measure-physical-performance",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("blog.readMore")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text",
                                  attrs: {
                                    rounded: "",
                                    small: "",
                                    color: "primary",
                                    href: "https://www.driblab.com/contact",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.contactUs")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-footer",
        {
          staticClass: "pt-1 pb-1",
          attrs: {
            fixed: "",
            width: "100%",
            color: "brandDark",
            height: "auto",
          },
        },
        [
          _c(
            "v-alert",
            {
              staticClass: "pa-4 mt-3 body-1",
              attrs: { width: "100%", dismissible: "" },
            },
            [
              _c("span", { staticClass: "body-font" }, [
                _vm._v(_vm._s(_vm.$t("login.cookiesText"))),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "monospace-font h1",
                  attrs: {
                    text: "",
                    small: "",
                    exact: "",
                    href: "https://policies.google.com/technologies/cookies?hl=en",
                    target: "_blank",
                    color: "primary",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("scoutingCalendar.moreInfo")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center justify-space-between" },
            [
              _c("p", { staticClass: "monospace-font white--text mb-0 me-5" }, [
                _vm._v(
                  _vm._s(`© ${_vm.currentYear} DRIBLAB. All rights reserved`)
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "monospace-font white--text",
                  attrs: {
                    text: "",
                    "x-large": "",
                    href: "http://www.driblab.com/contact",
                    target: "_blank",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("login.contact")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
        ],
        1
      ),
      _vm._v(" "),
      _c("ConfirmationModal", {
        ref: "confirmationForceModal",
        attrs: { title: "login.forceTitle", message: "login.forceMessage" },
        on: {
          confirmation: function ($event) {
            return _vm.onForceLoginConfirmation($event)
          },
        },
      }),
      _vm._v(" "),
      _c("NewPassFormModal", {
        ref: "newPassFormModal",
        on: {
          save: function ($event) {
            return _vm.onSaveNewPass($event)
          },
        },
      }),
      _vm._v(" "),
      _c("ForgotPasswordModal", {
        ref: "forgotPasswordFormModal",
        on: {
          save: function ($event) {
            return _vm.onForgotPasswordConfirm($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }